import React, { useEffect, useState } from 'react';
import { Table, Typography, Button, Tag, Modal, message, Row, Col, Input, Card,Select,Popconfirm } from 'antd';
import GenericAddRemoveMultipleRecords from "./GenericAddRemoveMultipleRecordsUI";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { currencyMap } from "../Components/Constant";
import Cookies from 'js-cookie';

const { Title, Link } = Typography;

const ManageCurrency = () => {
  const [currencies, setCurrencies] = useState([]);
  const [activeCurrencies, setActiveCurrencies] = useState([]);
  const [inactiveCurrencies, setInactiveCurrencies] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [changeCorporateModalVisible, setChangeCorporateModalVisible] = useState(false);
  const [editRatesModalVisible, setEditRatesModalVisible] = useState(false);
  const [inactiveEditConversionRates, setInactiveEditConversionRates] = useState(false);
  const [inactiveEditRatesModalVisible, setInactiveEditRatesModalVisible] = useState(false);
  const [isEditingActive, setIsEditingActive] = useState(true); 
  const [step, setStep] = useState(1);
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);
  const [currenciesForNewButton, setCurrenciesForNewButton] = useState([]);
  const [conversionRates, setConversionRates] = useState({});
  const [mappedCurrencyMap,setMappedCurrencyMap] = useState({});
  const [coorporateCurrency,setCoorporateCurrency] = useState({});
  const [selectedCorporateCode, setSelectedCorporateCode] = useState(null);
  const [editConversionRates, setEditConversionRates] = useState({});

  const fetchCurrencies = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/`,
        { "Content-Type": "application/json" },
        "GET"
      );
  
      const response = await apiService.makeCall();
      const data = response || [];
  
      setCurrencies(data);
      setActiveCurrencies(data?.filter((cur) => cur.active));
      setInactiveCurrencies(data?.filter((cur) => !cur.active));
  
      const corporate = data.find(cur => cur.coorporate); // spelling is correct
      setCoorporateCurrency(corporate);
      setSelectedCorporateCode(corporate?.iso_code); // <-- fix here
  
    } catch (error) {
      console.log('Failed to fetch currencies',error);
    }
  };
  

  useEffect(() => {
    const keyCurrencyMap = currencyMap.map((item) => ({
      ...item,
      key: item._id,
    }));
    setMappedCurrencyMap(keyCurrencyMap);
    fetchCurrencies();
  }, []);

  const openActiveEditRatesModal = () => {
    const initialRates = {};
    console.log('activeCurrencies', activeCurrencies);
  
    activeCurrencies.forEach((cur) => {
      initialRates[cur?.iso_code] = cur.conversion_rate;
    });
  
    setEditConversionRates(initialRates);
    setIsEditingActive(true);
    setEditRatesModalVisible(true);
  };
  
  
  const openInactiveEditRatesModal = () => {
    const initialRates = {};
    inactiveCurrencies.forEach((cur) => {
      initialRates[cur?.iso_code] = cur.conversion_rate;
    });
    setEditConversionRates(initialRates);
    setIsEditingActive(false);
    setEditRatesModalVisible(true);
  };
  const handleDeactivate = async (isoCode) => {
    try {
      const currency = currencies.find((cur) => cur?.iso_code === isoCode);
      if (!currency) {
        message.error("Currency not found");
        return;
      }
  
      const payload = {
        mt_currencies: [
          {
            id: currency._id,
            label: currency.label,
            active: false,
            coorporate: currency.coorporate,
            conversion_rate: currency.conversion_rate,
            iso_code:currency.iso_code
          }
        ]
      };
      console.log('selectedCorporateCode',selectedCorporateCode);
      Cookies.set('userCurrency', selectedCorporateCode, { expires: 7 });
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/bulk_update`,
        { "Content-Type": "application/json" },
        "PATCH",
        payload
      );
  
      await apiService.makeCall();
      message.success(`${currency.label} deactivated successfully`);
      fetchCurrencies();
    } catch (error) {
      console.error(error);
      message.error("Failed to deactivate currency");
    }
  };
  

  const handleActivate = async (isoCode) => {
    try {
      const currency = currencies.find((cur) => cur?.iso_code === isoCode);
      if (!currency) {
        message.error("Currency not found");
        return;
      }
  
      const payload = {
        mt_currencies: [
          {
            id: currency._id,
            label: currency.label,
            active: true,
            coorporate: currency.coorporate,
            conversion_rate: currency.conversion_rate,
            iso_code: currency.iso_code
          }
        ]
      };
  
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/bulk_update`,
        { "Content-Type": "application/json" },
        "PATCH",
        payload
      );
  
      await apiService.makeCall();
      message.success(`${currency.label} activated successfully`);
      fetchCurrencies();
    } catch (error) {
      console.error(error);
      message.error("Failed to activate currency");
    }
  };
  
  const handleUpdateCorporateCurrency = async () => {
    if (!selectedCorporateCode || selectedCorporateCode === coorporateCurrency?.iso_code) {
      message.info("No change made");
      return;
    }
  
    const newCorporate = [...activeCurrencies, ...inactiveCurrencies].find(
      (c) => c?.iso_code === selectedCorporateCode
    );
  
    if (!newCorporate || !newCorporate.conversion_rate) {
      message.error("Selected currency has invalid conversion rate");
      return;
    }
  
    const newCorporateRate = newCorporate.conversion_rate;
  
    // Recalculate all other conversion rates
    const allCurrencies = [...activeCurrencies, ...inactiveCurrencies];
  
    const payload = {
      mt_currencies: allCurrencies.map((cur) => {
        const newRate =
          cur?.iso_code === newCorporate?.iso_code
            ? 1
            : parseFloat((cur.conversion_rate / newCorporateRate));
  
        return {
          id: cur._id,
          label: cur.label,
          active: cur.active,
          coorporate: cur?.iso_code === newCorporate?.iso_code,
          conversion_rate: newRate,
        };
      }),
    };
  
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/bulk_update`,
        { "Content-Type": "application/json" },
        "PATCH",
        payload
      );
  
      await apiService.makeCall();
      message.success("Corporate currency updated and rates adjusted");
      setChangeCorporateModalVisible(false);
      fetchCurrencies();
    } catch (err) {
      console.error(err);
      message.error("Failed to update corporate currency");
    }
  };
  
  
  
  const handleSaveSelected = async () => {
    const currency_details = [];
  
    selectedCurrencies.forEach((key) => {
      const found = currencyMap.find((c) => c._id === key);
      if (!found) return;
  
      currency_details.push({
        label: found.Name,
        name:found.Name.split('(')[1]?.replace(')', '') || found.Name,
        iso_code: found.Name.split('(')[1]?.replace(')', '') || found.Name,
        symbol: key,
        active: true,
        coorporate: false,
        conversion_rate: parseFloat(conversionRates[key]),
      });
    });
  
    const payload = {
      mt_currencies: currency_details, // plural key
    };
  
    console.log('payload', payload);
  
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/`,
        { "Content-Type": "application/json" },
        "POST",
        payload
      );
      const response = await apiService.makeCall();
      message.success('Currencies saved successfully');
      setModalVisible(false);
      setSelectedCurrencies([]);
      setConversionRates({});
      setStep(1);
      fetchCurrencies();
    } catch (error) {
      message.error('Failed to save currencies');
    }
  };
  

  const handleEditConversionRates = async () => {
    const allCurrencies = [...activeCurrencies, ...inactiveCurrencies];
  
    const payload = allCurrencies
      .filter((cur) => editConversionRates[cur?.iso_code] !== '' && !isNaN(editConversionRates[cur?.iso_code]))
      .map((cur) => ({
        id: cur._id,
        label: cur.label,
        active: cur.active,
        coorporate: cur.coorporate,
        conversion_rate: parseFloat(editConversionRates[cur?.iso_code]),
      }));
  
    if (payload.length === 0) {
      message.warning("No valid conversion rates to update");
      return;
    }
  
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/bulk_update`,
        { "Content-Type": "application/json" },
        "PATCH",
        { mt_currencies: payload }
      );
  
      await apiService.makeCall();
      message.success("Conversion rates updated successfully");
      setEditRatesModalVisible(false);
      setEditConversionRates({});
      fetchCurrencies();
    } catch (error) {
      message.error("Failed to update conversion rates");
    }
  };
  
  
  
  const activeColumns = [
    
    {
      title: 'Currency Code',
      dataIndex: 'iso_code',
      key: 'iso_code',
    },
    {
      title: 'Currency Name',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: 'Corporate',
      dataIndex: 'coorporate',
      key: 'coorporate',
      render: (value) => (value ? <Tag color="blue">✓</Tag> : null),
    },
    {
      title: 'Conversion Rate',
      dataIndex: 'conversion_rate',
      key: 'conversion_rate',
    },
    {
  title: 'Action',
  key: 'action',
  render: (_, record) => (
    <>
      {/* <Link>Edit</Link> */}
      {!record.coorporate && (
        <Popconfirm
          title={`Are you sure you want to deactivate ${record.name}?`}
          okText="Yes"
          cancelText="No"
          onConfirm={() => handleDeactivate(record?.iso_code)}
        >
          <Typography.Link style={{ color: 'red' }}>
            Deactivate
          </Typography.Link>
        </Popconfirm>
      )}
    </>
  ),
}

  ];

  const inactiveColumns = [
    
    {
      title: 'Currency Code',
      dataIndex: 'iso_code',
      key: 'iso_code',
    },
    {
      title: 'Currency Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Conversion Rate',
      dataIndex: 'conversion_rate',
      key: 'conversion_rate',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          {/* <Link>Edit</Link> */}
          {!record.corporate && (
            <>
              {/* {' | '} */}
              <Link onClick={() => handleActivate(record?.iso_code)}>Activate</Link>
            </>
          )}
        </>
      ),
    }
  ];

  const handleNewButtonClick = () =>{
    const alreadyUsedIsoCodes = [
      ...activeCurrencies.map(c => c?.iso_code),
      ...inactiveCurrencies.map(c => c?.iso_code),
    ];
    
    const availableCurrencies = currencyMap.filter(
      (c) => !alreadyUsedIsoCodes.includes(c.code)
    );
    
    setCurrenciesForNewButton(availableCurrencies);
    setModalVisible(true);
  }

  const handleChangeCorporate = () =>{  
    setChangeCorporateModalVisible(true);
    setSelectedCorporateCode(null);
  }
  return (
    <div style={{ padding: '24px' }}>
      <Card title={ <Title level={4} >
          Manage Currencies
        </Title>} bordered={false}>
        <Title level={4} >
          Active Currencies
        </Title>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
        <Button type="primary" style={{ marginRight: 8 }} onClick={handleNewButtonClick}>New</Button>
        <Button onClick={openActiveEditRatesModal}>Edit Rates</Button>
        <Button style={{ marginLeft: 8 }} onClick={handleChangeCorporate}>Change Corporate</Button>
        </div>
        <Table
          columns={activeColumns}
          dataSource={activeCurrencies}
          pagination={false}
          scroll={{
            // x: '100vw',
            y: 250
          }}
          bordered
          size="middle"
          rowKey="_id"
          style={{ marginBottom: 32 }}
        />
  
        <Title level={4}>
        Inactive Currencies
      </Title>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
        <Button onClick={openInactiveEditRatesModal}>Edit Rates</Button>
        </div>
        <Table
          columns={inactiveColumns}
          dataSource={inactiveCurrencies}
          pagination={false}
          scroll={{
            // x: '100vw',
            y: 250
        }}
          bordered
          size="middle"
          rowKey="_id"
        />
      </Card>
  
      <Modal
        title={step === 1 ? 'Select Currencies' : 'Set Conversion Rates'}
        open={modalVisible}
        width={800}
        zIndex={1002}   // higher than sidebar
        onCancel={() => {
          setModalVisible(false);
          setStep(1);
          setSelectedCurrencies([]);
          setConversionRates({});
        }}
        footer={null}
      >
        <div style={{ maxHeight: 500, overflowY: 'auto', paddingRight: 8 }}>
          {step === 1 ? (
            <GenericAddRemoveMultipleRecords
              titleLeft="Available Currencies"
              titleRight="Selected Currencies"
              dataSource={currenciesForNewButton}
              selectedKeys={selectedCurrencies}
              onUpdateSelectedKeys={setSelectedCurrencies}
              columnsLeft={[{ title: "Name", dataIndex: "Name", key: "Name" }]}
              columnsRight={[{ title: "Name", dataIndex: "Name", key: "Name" }]}
              searchFields={["Name"]}
            />
          ) : (
            selectedCurrencies?.map((key) => {
              const selected = currencyMap.find((c) => c._id === key);
              return (
                <Row
                  key={key}
                  gutter={12}
                  align="middle"
                  style={{
                    marginBottom: 12,
                    padding: '8px 12px',
                    border: '1px solid #f0f0f0',
                    borderRadius: 6,
                    background: '#fafafa',
                  }}
                >
                  <Col span={14}>
                    <strong>{selected?.Name}</strong>
                  </Col>
                  <Col span={10}>
                    <Input
                      type="number"
                      step="0.0001"
                      value={conversionRates[key] || ''}
                      onChange={(e) =>
                        setConversionRates({ ...conversionRates, [key]: e.target.value })
                      }
                      placeholder="Enter conversion rate"
                    />
                  </Col>
                </Row>
              );
            })
          )}
        </div>
  
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Button onClick={() => {
            setModalVisible(false);
            setStep(1);
            setSelectedCurrencies([]);
            setConversionRates({});
          }}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => {
              if (step === 1) {
                setStep(2);
              } else {
                handleSaveSelected();
              }
            }}
            style={{ marginLeft: 8 }}
          >
            {step === 1 ? 'Next' : 'Save'}
          </Button>
        </div>
      </Modal>
      <Modal
        title="Update Corporate Currency"
        open={changeCorporateModalVisible}
        width={600}
        zIndex={1002}   // higher than sidebar
        onCancel={() => {
          setChangeCorporateModalVisible(false);
          setSelectedCorporateCode(null); 
        }}
        footer={null}
      >
        <div style={{ marginBottom: 16 }}>
          <strong>Current Corporate Currency:</strong>
          <div style={{ marginTop: 4 }}>
            {coorporateCurrency?.name || 'Not set'}
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <strong>Select New Corporate Currency:</strong>
          <Select
            showSearch
            style={{ width: '100%', marginTop: 8 }}
            placeholder="Select currency"
            value={selectedCorporateCode}
            onChange={(value) => setSelectedCorporateCode(value)}
          >
            {activeCurrencies
              .filter((cur) => cur?.iso_code !== coorporateCurrency?.iso_code)
              .map((cur) => (
                <Select.Option key={cur?.iso_code} value={cur?.iso_code}>
                  {cur.name}
                </Select.Option>
            ))}

          </Select>
        </div>

        <div style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              setChangeCorporateModalVisible(false);
              setSelectedCorporateCode(null); // reset
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 8 }}
            onClick={handleUpdateCorporateCurrency}  
          >
            Save
          </Button>
        </div>
      </Modal>
      <Modal
        title="Edit Conversion Rates"
        open={editRatesModalVisible}
        width={600}
        zIndex={1002}   // higher than sidebar
        onCancel={() => {
          setEditRatesModalVisible(false);
          setEditConversionRates({});
        }}
        footer={null}
      >
        <div style={{ maxHeight: 400, overflowY: 'auto', paddingRight: 8 }}>
          {(isEditingActive ? activeCurrencies : inactiveCurrencies).map((cur) => (
            <Row
              key={cur?.iso_code}
              gutter={12}
              align="middle"
              style={{
                marginBottom: 12,
                padding: '8px 12px',
                border: '1px solid #f0f0f0',
                borderRadius: 6,
                background: '#fafafa',
              }}
            >
              <Col span={14}>
                <strong>{cur.name}</strong>
                {cur.coorporate && (
                <Tag color="blue" style={{ marginLeft: 8 }}>
                    Corporate Currency
                  </Tag>
                )}

              </Col>
              <Col span={10}>
                <Input
                  type="number"
                  step="0.0001"
                  value={editConversionRates[cur?.iso_code] !== undefined ? String(editConversionRates[cur?.iso_code]) : ''}
                  onChange={(e) =>
                    setEditConversionRates({
                      ...editConversionRates,
                      [cur?.iso_code]: e.target.value,
                    })
                  }                  
                  placeholder="Enter conversion rate"
                  disabled={cur.coorporate}
                />
              </Col>
            </Row>
          ))}
        </div>

        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Button
            onClick={() => {
              setEditRatesModalVisible(false);
              setEditConversionRates({});
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 8 }}
            onClick={() =>
              handleEditConversionRates(isEditingActive ? activeCurrencies : inactiveCurrencies)
            }
          >
            Save
          </Button>
        </div>
      </Modal>

    </div>
  );
  
};

export default ManageCurrency;
